'use client';
import React from 'react';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import { Box, Stack } from '@mui/material';
import CustomImage from '@components/CustomImage';
import SplideSlider from '@components/SplideSlider';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import CommonContainer from '@components/CommonContainer';
import cn from './style.module.scss';

export default function EastvaleWellness(props: MarketingPageComponentProps) {
  const wellnessSection = props?.locale?.section?.find(
    (section: any) => section.type === 'wellness' && section.enabled
  );
  if (!wellnessSection) return null;

  const eastvaleWellnesssliderData =
    wellnessSection?.eastvaleWellnessSlider ?? [];
  const lsqeastvaleWellnessSettings = {
    type: 'loop',
    autoplay: true,
    rewind: true,
    speed: 1000,
    interval: 3000,
    padding: { left: '20%', right: '20%' },
    breakpoints: {
      900: {
        padding: { left: '60px', right: '60px' },
      },
    },
  };

  return (
    <Stack
      component="section"
      className={cn.eastvaleWellnessWrapper}
      id="eastvaleWellness"
    >
      <Box className={cn.eastvaleWellnessInner}>
        <Box className={cn.eastvaleWellnessBlock}>
          <Box className={cn.eastvaleWellnessContent}>
            <CommonContainer
              paddingInline={{ xs: '32px', sm: '32px', md: '24px' }}
              maxWidth={{ xs: '100%', md: '1200px', lg: '1400px' }}
              flexGrow={1}
            >
              <Box className={cn.eastvaleWellnessHeader}>
                <Box className={cn.eastvaleWellnessHeader__title}>
                  <ParallaxText
                    variant="h2"
                    animationType="slideInBottom"
                    animationDuration={900}
                  >
                    {ReactHtmlParser(wellnessSection?.eastvaleWellnessHeading)}
                  </ParallaxText>
                </Box>
                <Box className={cn.eastvaleWellnessHeader__data}>
                  <ParallaxText
                    variant="p"
                    animationType="slideInBottom"
                    animationDuration={900}
                    animationDelay={200}
                  >
                    {ReactHtmlParser(wellnessSection?.eastvaleWellnessContent)}
                  </ParallaxText>
                </Box>
              </Box>
            </CommonContainer>
          </Box>
          <Box className={cn.eastvaleWellnessStory}>
            <SplideSlider
              showArrows
              options={lsqeastvaleWellnessSettings}
              trackClassName={cn.eastvaleWellnessTrack}
              slideClassName={cn.eastvaleWellnessSlide}
              activeSlideClassName={cn.eastvaleWellnessActive}
              arrowsClassName={cn.eastvaleWellnessArrow}
              prevClassName={cn.galleryArrowPrevious}
              nextClassName={cn.galleryArrowNext}
            >
              {eastvaleWellnesssliderData.map((item: any, index: number) => (
                <Box className={cn.eastvaleWellnessItem} key={index}>
                  <Box className={cn.eastvaleWellnessElement}>
                    <CustomImage
                      src={item.url}
                      alt={item.alt}
                      width={768}
                      height={768}
                    />
                  </Box>
                </Box>
              ))}
            </SplideSlider>
          </Box>
        </Box>
      </Box>
    </Stack>
  );
}
